<ng-template #labelContent>
  @if (icon) {
    <i [class]="icon" aria-hidden="true"></i>
  }
  @if (label) {
    <span>{{ label }}</span>
  }
</ng-template>

@if (link) {
  <a class="inline-flex items-center gap-2 rounded-full border font-[650] leading-[1.2] no-underline transition-[transform,background,border-color,box-shadow] duration-150 ease-[cubic-bezier(0.25,0.1,0.25,1)] hover:-translate-y-px focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[3px] focus-visible:outline-[#ffb067] motion-reduce:transition-none motion-reduce:hover:transform-none"
     [ngClass]="variantClasses"
     [routerLink]="link"
     [queryParams]="queryParams">
    <ng-container [ngTemplateOutlet]="labelContent"></ng-container>
  </a>
} @else {
  <button type="button"
          class="inline-flex cursor-pointer items-center gap-2 rounded-full border font-[650] leading-[1.2] transition-[transform,background,border-color,box-shadow] duration-150 ease-[cubic-bezier(0.25,0.1,0.25,1)] hover:-translate-y-px focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[3px] focus-visible:outline-[#ffb067] motion-reduce:transition-none motion-reduce:hover:transform-none"
          [ngClass]="variantClasses"
          (click)="pressed.emit($event)">
    <ng-container [ngTemplateOutlet]="labelContent"></ng-container>
  </button>
}
